const waitForUpdateMs = 500;

const consentTypeMap = {
  marketing: ['ad_storage', 'ad_personalization'],
  statistics: ['analytics_storage'],
  necessary: ['functionality_storage'],
  performance: ['personalization_storage'],
  others: ['ad_user_data'],
};

class GtmUtils {
  getDataLayer() {
    return window.dataLayer || [];
  }

  gtag() {
    this.getDataLayer().push(arguments);
  }

  pushEventToDataLayer(name) {
    this.getDataLayer().push({
      event: name,
    });
  }

  getConsentLabel(isConsentGiven = true) {
    return isConsentGiven === true ? 'granted' : 'denied';
  }

  /**
   * Generates a consent object based on the provided consent data.
   *
   * @param {Object} consentData An object containing consent data.
   * @param {boolean} consentData.marketing Indicates whether marketing consent is given.
   * @param {boolean} consentData.statistics Indicates whether statistics consent is given.
   * @param {boolean} consentData.necessary Indicates whether necessary consent is given.
   * @param {boolean} consentData.performance Indicates whether performance consent is given.
   *
   * @returns {Object} The generated consent object.
   * The generated consent object contains properties based on the consent categories:
   * - For each category with consent, the corresponding consent type from consentTypeMap is mapped to 'granted'.
   * - For each category without consent, the corresponding consent type from consentTypeMap is mapped to 'denied'.
   */
  generateConsentObject(consentData) {
    const consentObject = {};
    consentData.forEach((entry) => {
      const consents = consentTypeMap[entry.name];
      const label = this.getConsentLabel(entry.value);
      consents.forEach((consent) => (consentObject[consent] = label));
    });
    return consentObject;
  }

  pushConsent(consentData, asUpdated = false) {
    this.gtag('consent', asUpdated ? 'update' : 'default', {
      ...this.generateConsentObject(consentData),
      wait_for_update: waitForUpdateMs,
    });
  }

  pushDefaultConsent(consentData) {
    this.pushConsent(consentData, false);
    this.pushEventToDataLayer('default_consent');
  }

  pushUpdatedConsent(consentData) {
    this.pushConsent(consentData, true);
  }
}

const GtmUtilsInstance = new GtmUtils();
export { GtmUtilsInstance as GtmUtils };
